import React, { useEffect, ReactNode } from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastProps {
  message: ReactNode;
  type: ToastType;
  onClose: () => void;
  onUndo?: () => void;
  duration?: number;
}

export const Toast: React.FC<ToastProps> = ({ message, type, onClose, onUndo, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const baseClasses = "rounded-lg p-4 text-white flex items-center justify-between shadow-lg";
  const typeClasses = {
    success: "bg-green-600",
    error: "bg-red-600",
    info: "bg-blue-600",
    warning: "bg-amber-500"
  };

  return (
    <div className={`${baseClasses} ${typeClasses[type]}`}>
      <div className="mr-4">{message}</div>
      <div className="flex items-center gap-2">
        {onUndo && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onUndo();
              onClose();
            }}
            className="text-white hover:text-gray-200 focus:outline-none text-sm underline"
          >
            Undo
          </button>
        )}
        <button
          onClick={onClose}
          className="text-white hover:text-gray-200 focus:outline-none"
        >
          ×
        </button>
      </div>
    </div>
  );
}; 